import { render, staticRenderFns } from "./NoBillTips.vue?vue&type=template&id=3d15b8c0&scoped=true&"
import script from "./NoBillTips.vue?vue&type=script&lang=js&"
export * from "./NoBillTips.vue?vue&type=script&lang=js&"
import style0 from "./NoBillTips.vue?vue&type=style&index=0&id=3d15b8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15b8c0",
  null
  
)

export default component.exports